import RichText from '../rich-text'
import { cx } from '@/utils/strings'
import { isPrint } from '@/utils/print'

export default function Callout({ title, body }: Props): JSX.Element {
  const isPrintView = isPrint()
  return (
    <div
      className={cx(
        'bg-white dark:bg-secondary-800 mb-4 border-secondary-100  border-b-2 break-inside-avoid p-4 [&_p]:last:mb-0!',
        isPrintView ? 'rounded-2xl [&_p]:mb-3' : 'rounded-lg md:p-6'
      )}
    >
      {title && <h4 className="text-xl mb-2">{title}</h4>}
      <RichText body={body} />
    </div>
  )
}
